/**
 * Business rule: patients may reschedule/cancel only while the appointment is more than
 * RESCHEDULE_CANCEL_WINDOW_HOURS away. Kept isolated here so it's easy to find/adjust without
 * touching the page itself.
 */
export const RESCHEDULE_CANCEL_WINDOW_HOURS = 72;

export const isWithinRescheduleCancelWindow = (appointmentDateTime: Date, now: Date = new Date()): boolean => {
  const hoursUntilAppointment = (appointmentDateTime.getTime() - now.getTime()) / (1000 * 60 * 60);
  return hoursUntilAppointment < RESCHEDULE_CANCEL_WINDOW_HOURS;
};

/**
 * Business rule: the virtual appointment join button only appears once the appointment is
 * within JOIN_WINDOW_MINUTES_BEFORE minutes away (date and time both, not clock-time alone).
 */
export const JOIN_WINDOW_MINUTES_BEFORE = 15;

export const canJoinVirtualAppointment = (appointmentDateTime: Date, now: Date = new Date()): boolean => {
  const minutesUntilAppointment = (appointmentDateTime.getTime() - now.getTime()) / (1000 * 60);
  return minutesUntilAppointment < JOIN_WINDOW_MINUTES_BEFORE;
};

/**
 * Business rule: reschedule/cancel only make sense for an appointment DrChrono still considers
 * active - one already Cancelled/Complete/No-Show/Late Cancel (or a "& Discharged from Practice"/
 * "no follow-up recommended" variant of those) has nothing left to change. Expressed as an
 * allow-list of the (small, stable) active statuses rather than an exclusion-list of every
 * possible closed status DrChrono can report, so an as-yet-unlisted closed-status variant is
 * still correctly treated as inactive instead of silently falling through as active.
 */
const ACTIVE_APPOINTMENT_STATUSES = ['Confirmed', 'Scheduled'];

export const isInactiveAppointmentStatus = (status?: string): boolean =>
  !!status && !ACTIVE_APPOINTMENT_STATUSES.includes(status);
